export const SELECTED_CUSTOMER_STORAGE_KEY = "selectedCustomerId";

export const readSelectedCustomerId = (): string | null =>
  sessionStorage.getItem(SELECTED_CUSTOMER_STORAGE_KEY) ||
  localStorage.getItem(SELECTED_CUSTOMER_STORAGE_KEY);

export const storeSelectedCustomerId = (customerId: string): void => {
  // sessionStorage keeps an open tab pinned to its own customer. localStorage
  // remains the default for a future tab or browser session.
  sessionStorage.setItem(SELECTED_CUSTOMER_STORAGE_KEY, customerId);
  localStorage.setItem(SELECTED_CUSTOMER_STORAGE_KEY, customerId);
};

export const clearSelectedCustomerId = (): void => {
  sessionStorage.removeItem(SELECTED_CUSTOMER_STORAGE_KEY);
  localStorage.removeItem(SELECTED_CUSTOMER_STORAGE_KEY);
};
